"use strict";

/**
 * @description Initializes the "password meets requirements" functionality
*/

function passwordRequirements() {
    const requirementsContainer = document.querySelector(".js-password-requirements");

    if (requirementsContainer !== null) {
        const passwordInput = requirementsContainer.previousElementSibling.querySelector(".js-input-password");

        if (passwordInput) {
            passwordInput.addEventListener("input", function () {
                const $this = this;
                let inputValue = $this.value;

                const requirements = Array.from(document.querySelectorAll(".js-password-requirement"));

                requirements.forEach(requirement => {
                    let regex = requirement.getAttribute("data-regex") || "[]";
                    inputValue.match(new RegExp(regex)) ?
                        requirement.classList.add("selected") :
                        requirement.classList.remove("selected");
                });
            });
        }
    }
}

module.exports = passwordRequirements;
